// extracted by mini-css-extract-plugin
export default {"photo-modal__body":"PhotoModal_photo-modal__body__Pr8nO","photo-modal":"PhotoModal_photo-modal__mIFrN"};